module.exports = __webpack_public_path__ + "static/media/Prakort_Lean_Resume.56e30334.pdf";